import {equals, test} from 'ramda'
import {ChannelsNameType, MessageChannelsType} from 'auth/types/Passwordless'
import {CHANNELS, SILENT_AUTH_URL_TRIGGER, WHATSAPP_KEY} from '../constants'
import {ClaimsType} from '../types/Auth'

/**
 * Appends a param to the supplied URL, that will signal for the app to
 * silently try to authenticate the user, without asking for user's input.
 * @param url the url to append the trigger
 * @returns the appended url
 */
export const addSSOTrigger = (url: string): string =>
  test(/\?/, url)
    ? `${url}&${SILENT_AUTH_URL_TRIGGER}=1`
    : `${url}?${SILENT_AUTH_URL_TRIGGER}=1`

/**
 * Check if Auth0 phone number fallback picture
 * Auth0 fallback phone number users picture with
 * an url containing /avatar/[0-9].png
 *
 * @param picture the photo url
 *
 * @returns boolean
 */
export const isAuth0PhoneNumberFallbackPicture = (
  picture: ClaimsType['picture']
) => test(/avatars\/\d.png/, picture)

/**
 * A channel is a media from where a user can authenticate themselves.
 * This function will return the name of the channel if you pass the channel id
 * @param channel The channel id
 * @returns the channel name
 */
export const getChannelName = (
  channel: MessageChannelsType
): ChannelsNameType => CHANNELS[channel].name

/**
 * A channel is a media from where a user can authenticate themselves.
 * This function checks if the channel passed is from the WhatsApp type
 * @param channel The channel id
 * @returns the channel name
 */
export const getIsWhatsAppChannel = (channel: MessageChannelsType) =>
  equals(channel, WHATSAPP_KEY)
